import { render, staticRenderFns } from "./especies.vue?vue&type=template&id=c2348e6e"
import script from "./especies.vue?vue&type=script&lang=js"
export * from "./especies.vue?vue&type=script&lang=js"
import style0 from "./especies.vue?vue&type=style&index=0&id=c2348e6e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports